export const EVENT_TYPES = {
  CUSTOMER_SERVICE: "Customer Service",
  PENALTY: "Penalty",
};

export const COMPLAINT_STATUS = {
  OPEN: "Open",
  WAITING_REPLY: "Waiting Reply",
  REPLIED: "Replied",
  APPEALING: "Appealing",
  REVIEWING: "Reviewing",
  PENALTY_CONFIRMED: "Penalty Confirmed",
  APPEAL_SUCCESSFUL: "Appeal Successful",
  CLOSED: "Closed",
};

export const STATUS_CONFIG = {
  [COMPLAINT_STATUS.OPEN]: { label: "Open", color: "#22C55E", dot: "🟢" },
  [COMPLAINT_STATUS.WAITING_REPLY]: {
    label: "Waiting Reply",
    color: "#EAB308",
    dot: "🟡",
  },
  [COMPLAINT_STATUS.REPLIED]: { label: "Replied", color: "#3B82F6", dot: "🔵" },
  [COMPLAINT_STATUS.APPEALING]: {
    label: "Appealing",
    color: "#F97316",
    dot: "🟠",
  },
  [COMPLAINT_STATUS.REVIEWING]: {
    label: "Reviewing",
    color: "#A855F7",
    dot: "🟣",
  },
  [COMPLAINT_STATUS.PENALTY_CONFIRMED]: {
    label: "Penalty Confirmed",
    color: "#64748B",
    dot: "⚫",
  },
  [COMPLAINT_STATUS.APPEAL_SUCCESSFUL]: {
    label: "Appeal Successful",
    color: "#0D9488",
    dot: "🟢",
  },
  [COMPLAINT_STATUS.CLOSED]: { label: "Closed", color: "#EF4444", dot: "🔴" },
};

export const SUBJECT_OPTIONS = [
  "Driver Late",
  "No Show",
  "Wrong Pickup",
  "Poor Service",
  "Vehicle Issue",
];

/** Backend raw status values used by /ctrip-manage/events query */
export const API_STATUS_OPTIONS = [
  { value: "open", label: "Open" },
  { value: "replied", label: "Replied" },
  { value: "closed", label: "Closed" },
  { value: "penalty_received", label: "Penalty Received" },
  { value: "appealing", label: "Appealing" },
  { value: "appeal_auditing", label: "Appeal Auditing" },
  { value: "appeal_failed", label: "Appeal Failed" },
  { value: "appeal_passed", label: "Appeal Successful" },
  { value: "penalty_confirmed", label: "Penalty Confirmed" },
  { value: "penalty_executed", label: "Penalty Executed" },
  { value: "penalty_cancelled", label: "Penalty Cancelled" },
];

export const APPEAL_REASONS = [
  "Driver had valid reason",
  "Customer no-show",
  "Incorrect penalty amount",
  "System error",
  "Other",
];

export const CS_EVENT_TYPE_OPTIONS = [
  { id: 15821, name_cn: "下单预订问题", name_en: "Booking & Reservation Issues" },
  { id: 15835, name_cn: "订单费用支付问题", name_en: "Order Payment Issues" },
  { id: 15856, name_cn: "优惠券使用问题", name_en: "Coupon Usage Issues" },
  { id: 15870, name_cn: "行李人数问题", name_en: "Passenger & Luggage Issues" },
  { id: 15905, name_cn: "订单取消修改问题", name_en: "Order Cancellation & Modification Issues" },
  { id: 15919, name_cn: "订单派车问题", name_en: "Vehicle Dispatch Issues" },
  { id: 15954, name_cn: "司乘联系问题", name_en: "Driver & Passenger Communication Issues" },
  { id: 15947, name_cn: "订单退赔款问题", name_en: "Refund & Compensation Issues" },
  { id: 15968, name_cn: "定位或导航问题", name_en: "Location & Navigation Issues" },
  { id: 15982, name_cn: "行驶路线问题", name_en: "Route Issues" },
  { id: 15996, name_cn: "发票和报销凭证问题", name_en: "Invoice & Reimbursement Receipt Issues" },
  { id: 16010, name_cn: "司机服务质量问题", name_en: "Driver Service Quality Issues" },
  { id: 16024, name_cn: "客服服务质量问题", name_en: "Customer Service Quality Issues" },
  { id: 16038, name_cn: "其他业务咨询", name_en: "Other Business Inquiries" },
  { id: 16052, name_cn: "加盟问题", name_en: "Partnership & Franchise Issues" },
  { id: 16066, name_cn: "账户信息问题", name_en: "Account Information Issues" },
  { id: 16080, name_cn: "司机分和补贴申请问题", name_en: "Driver Score & Subsidy Application Issues" },
  { id: 16094, name_cn: "判罚申诉问题", name_en: "Penalty Appeal Issues" },
];

export const DEFAULT_FILTERS = {
  orderId: "",
  eventId: "",
  eventType: "",
  status: "",
  subject: "",
  dateFrom: "",
  dateTo: "",
};
